import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


// fetch('/assets/app-env-config.json')
//   .then(res => res.json())
//   .then(appConfig => {
//      (window as any)['appConfig'] = appConfig; // make it globally accessible if needed
//    platformBrowserDynamic().bootstrapModule(AppModule)
//    .catch(err => console.error(err));
//   });
